import type { Context } from 'react';
import { useContext } from 'react';

export const useEnsureContextWithinProvider = <T>(
  context: Context<T | null>,
  displayName: string
): NonNullable<T> => {
  const returnedContext = useContext(context);

  if (returnedContext === null || returnedContext === undefined) {
    throw Error(
      `${displayName} context must be used in a ${displayName}Provider`
    );
  }

  return returnedContext;
};
